<template>
	<div>
		<div class="header header-fixed header-auto-show header-logo-app" style="transform: translate(0px, 0px);">

			<a href="/" class="header-title">اپلیکیشن برنامه ریزی و مدیریت کارها</a>
			<a href="#" data-menu="menu-main" class="header-icon header-icon-1"><i class="fas fa-bars"></i></a>
			<a href="#" data-toggle-theme="" class="header-icon header-icon-2 show-on-theme-dark"><i class="fas fa-sun"></i></a>
			<a href="#" data-toggle-theme="" class="header-icon header-icon-2 show-on-theme-light"><i class="fas fa-moon"></i></a>			
		</div>

		
		<div id="menu-main" class="menu menu-box-right menu-box-detached rounded-m" data-menu-width="260" data-menu-active="nav-welcome" data-menu-effect="menu-over" style="display: block; width: 260px;">
			<div class="menu-header">
				<a href="#" data-toggle-theme="" class="border-right-0"><i class="fa font-12 color-yellow-dark fa-lightbulb"></i></a>
				<a href="#" class="close-menu border-right-0"><i class="fa font-12 color-red-dark fa-times"></i></a>
			</div>
			<div class="menu-logo text-center">
				<h1 class="pt-3 font-800 font-28 text-uppercase">{{UserFullName}}</h1>
			</div>
			<div class="menu-items my-5">
				<router-link id="nav-welcome" to="/" class="nav-item-active">
					<i class="fa fa-home color-green1-light"></i>
					<span>صفحه اصلی</span>
				</router-link>
				<router-link id="nav-welcome" to="/OrgJobList" class="nav-item-active" v-if="isAdmin==true">
					<i class="fa fa-sitemap color-yellow2-dark"></i>
					<span>چارت سازمانی</span>
				</router-link>
				<router-link id="nav-welcome" to="/LocalUserList" class="nav-item-active" v-if="isAdmin==true">
					<i class="fa fa-users color-red1-light"></i>
					<span>لیست کاربران</span>
				</router-link>
				<router-link id="nav-welcome" to="/PersonList" class="nav-item-active" v-if="isMinify==false">
					<i class="fa fa-users color-blue1-light"></i>
					<span>اشخاص و مؤسسات</span>
				</router-link>
				<router-link id="nav-welcome" to="/TaskTypeList" class="nav-item-active">
					<i class="fa fa-check-circle color-blue2-dark"></i>
					<span>نوع کار</span>
				</router-link>
				<router-link id="nav-welcome" to="/OtherWorkTypeList" class="nav-item-active">
					<i class="fa fa-check-square color-magenta2-light"></i>
					<span>نوع فعالیت</span>
				</router-link>
				<router-link id="nav-welcome" to="/TaskNoteList" class="nav-item-active">
					<i class="fa fa-sticky-note color-pink1-dark"></i>
					<span>یادداشت های من</span>
				</router-link>
				<router-link id="nav-welcome" to="/About" class="nav-item-active">
					<i class="fa fa-info-circle color-magenta1-light"></i>
					<span>درباره</span>
				</router-link>

				<router-link id="nav-welcome" to="/NotificationList" class="nav-item-active">
					<i class="fa fa-comment-alt color-yellow1-light"></i>
					<span>پیام ها</span>
				</router-link>
				<router-link id="nav-welcome" to="/Help" class="nav-item-active">
					<i class="fa fa-question-circle color-pink2-light"></i>
					<span>راهنما</span>
				</router-link>
				<router-link id="nav-welcome" to="/ChangePass" class="nav-item-active">
					<i class="fa fa-lock color-orange-dark"></i>
					<span>تغییر رمز عبور</span>
				</router-link>
				<a id="nav-welcome" href="#" @click.prevent="SignOutUser()">
					<i class="fa fa-sign-out-alt color-red1-dark"></i>
					<span class="font-weight-bold">خروج</span>
				</a>
			</div>
			<!--<div class="text-center">
				<a href="#" class="icon icon-xs mr-1 rounded-s bg-facebook"><i class="fab fa-facebook"></i></a>
				<a href="#" class="icon icon-xs mr-1 rounded-s bg-twitter"><i class="fab fa-twitter"></i></a>
				<a href="#" class="icon icon-xs mr-1 rounded-s bg-instagram"><i class="fab fa-instagram"></i></a>
				<a href="#" class="icon icon-xs mr-1 rounded-s bg-linkedin"><i class="fab fa-linkedin-in"></i></a>
				<a href="#" class="icon icon-xs rounded-s bg-whatsapp"><i class="fab fa-whatsapp"></i></a>
				<p class="mb-0 pt-3 font-10 opacity-30">Copyright <span class="copyright-year"></span> Enabled. All rights reserved</p>
			</div>-->
		</div>
	</div>
</template>
<script>
    export default {
        computed: {
            IsUserAuthenticated() {
                return this.$store.getters.IsUserAuthenticated;
            },
            UserFullName() {
                return this.$store.getters.GetUserFullName;
			},
            isAdmin() {
                return this.$store.getters.GetIsAdmin;
            },
			isMinify() {
				return true;
            }
        },
        methods: {
			CheckForLogin() {
				if (this.$route.path != '/register') {
                    this.$store.dispatch("CheckForLogin");
                }
               
            },
            SignOutUser() {
                this.$store.dispatch("SignOutUser");
			},
			
			
        },
        created() {
			this.CheckForLogin();
            
        }
    };
</script>
